import React, { useEffect, useState } from 'react';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Box,
} from '@mui/material';

import MessageBatches from './MessageBatches';
import MessageDetails from './MessageDetails';
import Messages from './Messages';

import Config from '../../../Config';

import useAdminRequest from '../../../requests/AdminRequest';
import CustomModal from '../../common/CustomModal';

moment.locale('en-us');
momentLocalizer();

const MessageLog = (props) => {
  const [batch, setBatch] = useState({ messages: [] });
  const [showMessages, setShowMessages] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [detailsItem, setDetailsItem] = useState(null);
  const [filter, setFilter] = useState({
    onDate: new Date(),
    customer: '',
    user: '',
    withErrors: false,
    page: 1,
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const { getTrace } = useAdminRequest();

  const handleBatchSelect = (item) => {
    console.log(item);
    setBatch(item);
    setShowMessages(true);
  };

  const toggleDetails = (item) => {
    console.log(item);
    setDetailsItem(item);
    setShowDetails(true);
  };

  const refresh = async () => {
    setLoading(true);
    try {
      const data = await getTrace(
        {
          date: filter.onDate.toISOString(),
          customer: filter.customer,
          user: filter.user,
          withErrors: filter.withErrors,
          page: filter.page,
          pageSize: Config.defaultPL,
        },
        props.errorHandler
      );
      setData(data.items);
      setCount(data.total);
    } catch (error) {
      setSnackbarMessage(`Error: ${error.message}`);
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, [filter]);

  useEffect(() => {
    const modal = document.getElementById('messages-modal');
    console.log('modal', modal, showDetails);

    if (!modal) return;
    if (showDetails) {
      modal.parentElement.style.zIndex = 100;
    } else {
      modal.parentElement.style.zIndex = '';
    }
  }, [showDetails]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <MessageBatches
        count={count}
        data={data}
        loading={loading}
        filter={filter}
        onBatchSelect={handleBatchSelect}
        onFilterChange={setFilter}
        onRefresh={refresh}
      />

      <CustomModal
        title="Messages"
        width={1300}
        open={showMessages}
        setOpen={setShowMessages}
        onClose={() => setShowMessages(false)}
      >
        <Messages
          batch={batch}
          date={filter.onDate.toISOString()}
          onDetails={toggleDetails}
        />

        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button onClick={() => setShowMessages(false)} color="secondary">
            Close
          </Button>
        </Box>
      </CustomModal>

      <CustomModal
        title="Details"
        width={1300}
        open={showDetails}
        setOpen={setShowDetails}
        onClose={() => setShowDetails(false)}
      >
        <MessageDetails item={detailsItem} errorHandler={props.errorHandler} />

        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button onClick={() => setShowDetails(false)} color="secondary">
            Close
          </Button>
        </Box>
      </CustomModal>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
      />
    </>
  );
};

export default MessageLog;
